import { Story } from '../../DocTypes';

export const buttonsStory: Story = {
  title: 'Buttons',
  description: 'List with items having buttons',
  coreComponent: {
    html: `<tag-list
    avatar-src-field='image'
    avatar-placeholder-field='placeholder'
    avatar-size='40px'
    primary-field='name'
    button-1='Edit'
    button-2='View'>
  </tag-list>`,
    js: `var tagList = document.querySelector('tag-list');
  tagList.componentOnReady().then(function() {
    tagList.setData([
      {
        image:
          'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
        name: 'Jordan Norry',
        placeholder: 'JN',
      },
      {
        image: '',
        name: 'Sarah Young',
        placeholder: 'SY',
      },
      {
        image:
          'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
        name: 'Susan Warmly',
        placeholder: 'SW',
      }
    ]);
  });
  `,
  },
  reactWrapper: {
    jsx: `<TagList
  avatarSrcField='image'
  avatarPlaceholderField='placeholder'
  avatarSize='40px'
  primaryField='name'
  button1='Edit'
  button2='View'
  data={[
  {
    image:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=750&w=1260',
    name: 'Jordan Norry',
    placeholder: 'JN',
  },
  {
    image: '',
    name: 'Sarah Young',
    placeholder: 'SY',
  },
  {
    image:
      'https://images.pexels.com/photos/324658/pexels-photo-324658.jpeg?auto=compress&cs=tinysrgb&h=350',
    name: 'Susan Warmly',
    placeholder: 'SW',
  }
  ]}
  />`,
  },
};
